import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: { main: "#971FFD" },
    secondary: { main: "#3F3F40" },
    text: {
      primary: "#ffffff", // also for OutlinedInput:focus border-color
      secondary: "#757575",
    },
    error: { main: "#FF5F5F" },
  },
  typography: {
    fontFamily: ["Inter", "IRANYekan"].join(","),
  },
  shape: { borderRadius: 10 },
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { paddingTop: 12, paddingBottom: 12, fontWeight: 700 },
        textSecondary: {
          color: "#ffffff",
          ":disabled": { color: "#ffffff", opacity: 0.3 },
        },
        outlinedSecondary: {
          color: "#ffffff",
          borderWidth: 2,
          ":hover": { borderWidth: 2 },
        },
        containedPrimary: {
          ":disabled": {
            color: "#ffffff66",
            backgroundColor: "#29292D",
            "& svg": { opacity: 0.3 },
          },
        },
        sizeSmall: { paddingTop: 8, paddingBottom: 8, fontSize: "0.75rem" },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
        size: "small",
        inputProps: { dir: "auto" },
      },
      styleOverrides: {
        notchedOutline: {
          borderColor: "rgba(255, 255, 255, 0.1)",
          borderWidth: 1.5,
        },
        input: {
          "::placeholder": { fontSize: 12, textAlign: "right" },
        },
        sizeSmall: { fontSize: "0.875rem", input: { padding: "14px 14px" } },
      },
    },
    MuiFilledInput: {
      defaultProps: { disableUnderline: true, inputProps: { dir: "auto" } },
      styleOverrides: {
        root: {
          height: 40,
          boxSizing: "border-box",
          backgroundColor: "#29292D",
          borderRadius: 8,
          ":hover": {
            backgroundColor: "#29292D",
            borderRadius: 8,
          },
          "&.Mui-focused": {
            backgroundColor: "#29292D",
            borderRadius: 8,
          },
        },
        input: {
          "::placeholder": {
            fontSize: 12,
            textAlign: "right",
          },
          padding: 0,
          height: "100%",
          fontSize: 12,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: "12px",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#ffffff",
          fontSize: 14,
          fontWeight: 700,
          textAlign: "right",
          margin: 8,
          marginTop: 16,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        barColorPrimary: {
          borderRadius: 10,
          background:
            "linear-gradient(270deg, #971FFD 0%, rgba(151, 31, 253, 0.3) 100%)",
        },
        root: {
          backgroundColor: "#3E3445",
        },
      },
    },
    MuiTypography: {
      styleOverrides: { root: { color: "#ffffff" } },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          ".Mui-selected": { color: "#ffffff" },
          ":not(.Mui-selected)": { opacity: 0.3, color: "#ffffff" },
          minWidth: 0,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: { height: "64px", width: "64px", "& path": { color: "#212121" } },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundColor: "#1B1B20" },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorBottom: {
          borderTopRightRadius: 16,
          borderTopLeftRadius: 16,
          maxHeight: "70%",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          borderBottom: "2px solid rgba(255,255,255,0.11)",
        },
        indicator: {
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          flex: 1,
          padding: 0,
          minWidth: 0,
          fontWeight: 700,
          textTransform: "capitalize",
          "&.Mui-selected": { color: "#ffffff" },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root.MuiInputBase-root": {
            padding: "12px",
          },
        },
      },
    },
    MuiBadge: {
      defaultProps: {
        anchorOrigin: { vertical: "top", horizontal: "left" },
      },
      styleOverrides: {
        badge: {
          backgroundColor: "#FF60DC",
          color: "#ffffff",
          fontSize: "0.625rem",
          fontWeight: 700,
          fontFamily: "Inter",
          border: "solid 1.5px #ffffff",
        },
      },
    },
  },
});
